/**
 * Intercepts all fetch requests to automatically inject the Authorization header
 * and handles 401 unauthorized responses globally.
 */
export function setupFetchInterceptor() {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    let [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource instanceof Request ? resource.url : '';

    if (url.includes('/api/v1/')) {
      const token = localStorage.getItem('commonqr_token');

      if (token) {
        config = config || {};

        // Preserve existing headers correctly — spreading a Headers object
        // loses all entries, so we must use the Headers API instead.
        const existingHeaders = new Headers(config.headers);
        existingHeaders.set('Authorization', `Bearer ${token}`);
        config = { ...config, headers: existingHeaders };
      }
    }

    const response = await originalFetch(resource, config);

    // Global 401 handling
    if (response.status === 401 && url.includes('/api/v1/')) {
      if (!url.includes('/auth/login') && !url.includes('/auth/register')) {
        localStorage.removeItem('commonqr_token');
        if (window.location.pathname.startsWith('/dashboard')) {
          window.location.href = '/login';
        }
      }
    }

    return response;
  };
}